<form [formGroup]="form">
  <div class="mb-4">
    <p-iftalabel>
      <p-autocomplete
        fluid
        [dropdown]="customInstructions.length > 0"
        formControlName="name"
        id="instruction-name"
        placeholder="Select an instruction or type to create new"
        optionLabel="name"
        [suggestions]="customInstructionOptions"
        [disabled]="isLoading() || disabled"
        (completeMethod)="filterCustomInstructions($event)"
        (onSelect)="onSelect($event)" />
      <label for="instruction-content">Custom instruction name</label>
    </p-iftalabel>
  </div>

  <div class="space-y-2">
    <div>
      <p-iftalabel>
        <textarea
          pTextarea
          [fluid]="true"
          rows="10"
          cols="5"
          id="instruction-content"
          formControlName="content"
          placeholder='Example customizations you might try:
        Narrow the focus to one aspect (e.g., "just analyze the parents&#39; role in the story")
        Speak to a particular group (e.g., "write it for someone unfamiliar with economics")
        Use a particular source (e.g., "only use the article about climate change")
      '
          style="resize: vertical"
          [class.p-invalid]="isContentTooLong"
          [disabled]="isLoading() || disabled"></textarea>
        <label for="instruction-content">Custom instruction content</label>
      </p-iftalabel>

      <!-- Character Count -->
      <div class="flex justify-between items-center mt-1">
        <div class="text-xs text-gray-600">
          {{ contentLength }}/{{ maxContentLength }} characters
        </div>
        <div *ngIf="isContentTooLong" class="text-xs text-red-500">
          {{ contentValidationMessage }}
        </div>
      </div>

      <!-- Error Message -->
      <small *ngIf="error()" class="text-red-500">{{ error() }}</small>
    </div>

    <div class="flex justify-end gap-2">
      <p-button
        label="Save"
        icon="pi pi-save"
        size="small"
        [outlined]="true"
        severity="primary"
        [loading]="isSaving()"
        [disabled]="!form.valid || disabled"
        (click)="onSaveClick()"></p-button>

      <p-button
        label="Save As..."
        icon="pi pi-copy"
        size="small"
        [outlined]="true"
        severity="secondary"
        [disabled]="!selectedInstruction || !form.valid || disabled"
        (click)="onSaveAsClick()"></p-button>
    </div>
  </div>
</form>
